import i18n from 'i18next'

import en from './en.json'
import fr from './fr.json'

i18n.addResourceBundle('en', 'translation', en, true)
i18n.addResourceBundle('fr', 'translation', fr, true)
